<template>
  <div class="speaking-review">
    <QuestionReview v-if="items.length" :items="items" v-slot="{ item }">
      <article>
        <h3>{{ item.label }}</h3>
        <p class="prompt" lang="en">{{ item.kind === 'read' ? item.text : item.question }}</p>
        <p class="answer-label">{{ $t(item.kind === 'read' ? 'levelTest.recognizedSpeech' : 'levelTest.yourAnswer') }}</p>
        <p class="transcript" lang="en">{{ item.transcript || $t('levelTest.noTranscript') }}</p>
        <p v-if="item.kind === 'read'" class="measurement">
          {{ $t('levelTest.pronunciation') }} {{ item.pronunciation ?? '—' }}
          <span v-if="item.accuracy != null"> · {{ $t('levelTest.accuracy') }} {{ item.accuracy }}</span>
          <span v-if="item.fluency != null"> · {{ $t('levelTest.fluency') }} {{ item.fluency }}</span>
        </p>
        <template v-else>
          <p class="measurement"><span v-if="item.level">{{ item.level }}</span><span v-if="item.fluency != null"> · {{ $t('levelTest.fluency') }} {{ item.fluency }}</span><span v-if="item.speechDurationSeconds > 0"> · {{ $t('levelTest.wordsPerMinute', { n: item.wordsPerMinute }) }}</span></p>
          <p v-if="item.reason" class="feedback">{{ item.reason }}</p>
        </template>
      </article>
    </QuestionReview>
    <p v-else>{{ $t('levelTest.oldReport') }}</p>
  </div>
</template>

<script>
import QuestionReview from './QuestionReview.vue'

export default {
  name: 'SpeakingReview',
  components: { QuestionReview },
  props: { result: { type: Object, required: true } },
  computed: {
    items() {
      return [
        ...(this.result.readAloud || []).map((item, index) => ({ ...item, id: `read-${index}`, kind: 'read', label: this.$t('levelTest.readNumber', { n: index + 1 }) })),
        ...(this.result.answers || []).map((item, index) => ({ ...item, id: `answer-${index}`, kind: 'answer', label: this.$t('levelTest.answerNumber', { n: index + 1 }) }))
      ]
    }
  }
}
</script>

<style scoped>
.speaking-review { color: var(--ink-primary); text-align: left; font-size: var(--font-size-sm); line-height: 1.6; }
h3 { margin: 0; color: var(--ink-secondary); font-size: var(--font-size-sm); font-weight: 500; }
p { margin: var(--space-2) 0 0; }
.prompt { font-size: var(--font-size-md); font-weight: 500; }
.answer-label { margin-top: var(--space-4); color: var(--ink-secondary); font-size: var(--font-size-xs); }
.transcript { padding: var(--space-3); border-radius: var(--radius-sm); background: var(--surface-subtle); white-space: pre-wrap; }
.measurement { margin-top: var(--space-4); }
.feedback { color: var(--ink-secondary); }
</style>
